import { render, staticRenderFns } from "./DoughnutChart.v2.vue?vue&type=template&id=821389a8&scoped=true&"
import script from "./DoughnutChart.v2.vue?vue&type=script&lang=js&"
export * from "./DoughnutChart.v2.vue?vue&type=script&lang=js&"
import style0 from "./DoughnutChart.v2.vue?vue&type=style&index=0&id=821389a8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "821389a8",
  null
  
)

export default component.exports